function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 15.5,
  fill: "#FAFAFA",
  stroke: "#FAFAFA"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.4697 24.5303C15.7626 24.8232 16.2374 24.8232 16.5303 24.5303L21.3033 19.7574C21.5962 19.4645 21.5962 18.9896 21.3033 18.6967C21.0104 18.4038 20.5355 18.4038 20.2426 18.6967L16 22.9393L11.7574 18.6967C11.4645 18.4038 10.9896 18.4038 10.6967 18.6967C10.4038 18.9896 10.4038 19.4645 10.6967 19.7574L15.4697 24.5303ZM15.25 8L15.25 24H16.75V8H15.25Z",
  fill: "#FF6471"
});

var SvgNegative = function SvgNegative(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNegative, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/negative.36de74ed.svg";
export { ForwardRef as ReactComponent };